import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'
import { Button } from 'components/atoms/button'

interface ProducerInformationModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	title?: string
	description?: string
}

export function ProducerInformationModal({
	open,
	setOpen,
	title = 'Producer',
	description = 'Full control over the event. Can edit, assign roles, and appears on the event page.',
}: ProducerInformationModalProps) {
	return (
		<ConfirmationModal title={title} open={open} setOpen={setOpen}>
			<div>
				<div className="mb-8">{description}</div>
				<div className="space-y-2">
					<Button variant="secondary" fullWidth size="lg" onClick={() => setOpen(false)}>
						Close
					</Button>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface ProducerInformationModalManagedProps {
	title?: string
	description?: string
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'producer-information': ProducerInformationModalManagedProps
	}
}

export function ManagedProducerInformationModal({
	onClose,
	...rest
}: ProducerInformationModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<ProducerInformationModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			{...rest}
		/>
	)
}
